import PageScroller from './Modules/PageScroller';
import ViewVotesItem from './Modules/ViewVotes/ViewVoteItem';
import ViewVotesClient from './Modules/ViewVotes/ViewVotesClient';
import $ from 'jquery';
import 'bootstrap';
import Dialog from './Modules/Dialog';


class SearchResult extends ViewVotesClient {
    constructor(toggleAllStateButtonClassName, checkBoxClassName, dialogLinkClass, addButtonClass) {

        super(toggleAllStateButtonClassName, checkBoxClassName);

        const main = document.querySelector('main');
        const type = main instanceof HTMLElement ? main.dataset.catetgory : "";
        this._currentType = type ? type : "";

        const addAllButtons = document.getElementsByClassName(addButtonClass);
        for (let i = 0; i < addAllButtons.length; i++) {
            addAllButtons[i].addEventListener('click', this.add.bind(this), false);
        }

        window.addEventListener('storage', this.update.bind(this));
        this.update();

        new Dialog(dialogLinkClass);
    }
    add() {
        const itemElements = Array.from(document.querySelectorAll('.reading-checkbox:checked'));
        const items = itemElements.map((element) => {
            return this.convertElementToViewVotesItem(element);
        });

        const contentElem = document.getElementById('modal-content');
        if (contentElem instanceof HTMLElement) {
            try {
                this.manager.update();
                this.manager.add(items, true);
                setTimeout(() => {
                    contentElem.textContent = `${this.manager.getList(null).length}/5000件選択しています`;
                    $('#modal-dialog').modal();
                }, 0);
            }
            catch (e) {
                contentElem.textContent = "閲覧票は5000件まで選択できます";
                $('#modal-dialog').modal();
            }
        }
    }
    convertElementToViewVotesItem(object) {
        const id = object.dataset.id?.toString() ?? "";
        const cat = object.dataset.cat?.toString() ?? "";
        const catOrder = this.parseInt(object.dataset.catOrder);
        const refNum = object.dataset.refNum ?? "";
        const refNum2 = object.dataset.refNum2 ?? "";
        const docNumString = object.dataset.docNumString ?? "";

        const tempDocNum = this.parseInt(object.dataset.docNum);
        const docNum = !isNaN(tempDocNum) ? tempDocNum : 0;

        const docNumBranch1 = this.parseInt(object.dataset.docNumBranch1);
        const docNumBranch2 = this.parseInt(object.dataset.docNumBranch2);
        const title = object.dataset.docTitle ?? "";
        return new ViewVotesItem(id, cat, catOrder, refNum, refNum2, docNum, docNumString, title, 'application', 0, docNumBranch1, docNumBranch2);
    }
    parseInt(s) {
        if (!s)
            return 999;
        return parseInt(s);
    }
    update() {
        const votesList = this.getList(null);

        const itemElements = document.querySelectorAll('.reading-checkbox');
        for (let i = 0; i < itemElements.length; i++) {
            const value = itemElements[i];
            value.checked = votesList.some((val) => val.id === value.dataset.id);
        }
    }
}
{
    new PageScroller();
    new SearchResult('all-toggle-button', 'reading-checkbox', 'popup-link', 'add-btn');

    const fixedTable = () => {
        const tableWidth = $('table').width();

        const absoluteColumns = $('.absolute-width').get();
        if (!absoluteColumns || absoluteColumns.length === 0) return;

        const totalWidth = absoluteColumns.reduce((prev, current, index, array) => {
            const prevWidth = isNaN(prev) ? prev.offsetWidth : prev;
            return prevWidth + current.offsetWidth;
        });

        const availableWidth = tableWidth - totalWidth;
        const valiableColumns = $('.variable-width');
        valiableColumns.each((index, element) => {
            const percent = parseInt(element.dataset.widthPercentage);
            element.style.width = `${availableWidth * percent / 100}px`;
        });
    };
    window.addEventListener('resize', fixedTable);

    fixedTable();
}
